import 'bootstrap/js/tooltip';
import 'bootstrap/js/popover';
import url from 'url-helper';

/**
 * Radios
 */
function setupRadios() {
  $(document).on('click', '.radio span, .radio-inline span', function(){
    $(this).siblings('input[type=radio]').click();
  });
}

/**
 * Long loaders
 */
function setupLongLoaders() {
  $(document).on('submit', 'form.will-load-long', function(){
      $(this).find('[type=submit]').attr('disabled', 'disabled').addClass('loading');
  });

  $('.will-load:not([type=submit])').on('click', function(){
    $(this).attr('disabled', 'disabled').addClass('loading');
  });

  $('form.will-load-long').on('submit', function(){
      $(this).find('[type=submit]').attr('disabled', 'disabled').addClass('loading');
  });

  $('.ll-button').on('click', function(){
    $(this).attr('disabled', true).addClass('loading');
  })
}

/**
 * Dismissal
 */
function setupMisc() {
  $('.dismiss, [data-dismiss]').on('click', function(){
    $(this).parents('.dismiss-parent, .alert').fadeOut();
  })

  /**
   * Select on click
   */
  $(document).on("click", ".select-on-click", function () {
     $(this).select();
  });
}

/**
 * Post load function
 */
function setupPopovers() {
    $('.tap-popover, [tap-popover]').popover({
        trigger: 'manual'
    }).on("mouseenter", function () {
        var _this = this;
        $(this).popover("show");
        $(this).siblings(".popover").on("mouseleave", function () {
            $(_this).popover('hide');
        });
    }).on("mouseleave", function () {
        var _this = this;
        setTimeout(function () {
            if (!$(".popover:hover").length) {
                $(_this).popover("hide")
            }
        }, 100);
    });
}

function setupPopWindows() {
    $('.pop-window').each(function(){
        $(this).on('click', function(ev){
            ev.preventDefault();
            popWindow(this);
        });
    });
}

function popWindow(self) {
    return window.open($(self).attr('href'), 'popup', 'width=600,height=700,scrollbars=yes,resizable=yes,toolbar=no,directories=no,location=no,menubar=no,status=no');
}

function setupAlertDismissal() {
    $(document).on('click', '[data-dismiss="alert"]', function(){
        $(this).closest('.alert-dismissable').fadeOut();
    });
}

$(function(){
    setupRadios();
    setupPopovers();
    setupPopWindows();
    setupLongLoaders();
    setupMisc();
    setupAlertDismissal();
});
